var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.toastIsShow ? _c('div', {
    class: _vm.showAnimateContent ? 'fadein' : 'fadeout',
    attrs: {
      "id": "toast_shadow"
    }
  }, [_c('div', {
    staticClass: "mask-shadow2"
  }), _c('div', {
    staticClass: "toast-main-one"
  }, [_c('div', {
    staticClass: "team-tips"
  }, [_c('h3', {
    style: {
      'padding-top': _vm.toastSubText !== '' ? '54px' : '79px'
    }
  }, [_vm._v(_vm._s(_vm.toastText))]), _vm.toastSubText !== '' ? _c('p', [_vm._v(_vm._s(_vm.toastSubText))]) : _vm._e()]), _vm.twoBtnFlag ? _c('div', {
    staticClass: "make-sure"
  }, [_c('span', {
    on: {
      "click": _vm.clickCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _c('span', {
    on: {
      "click": _vm.clickSure
    }
  }, [_vm._v(_vm._s(_vm.sureText))])]) : _vm._e(), !_vm.twoBtnFlag ? _c('div', {
    staticClass: "make-one-sure",
    on: {
      "click": _vm.clickIKnow
    }
  }, [_vm._v("知道了")]) : _vm._e()])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };